{
	"name": "base-angular",
	"version": "19.5.129",
	"scripts": {
		"ng": "ng",
		"start": "ng serve",
		"start:ci": "ng serve --configuration ci",
		"start:bff:ci": "cd .. && npm run start:bff:ci",
		"build": "ng build",
		"build:prod": "ng build --configuration prod",
		"build:sandbox": "ng build --configuration sandbox",
		"build:staging": "ng build --configuration staging",
		"build:development": "ng build --configuration development",
		"watch": "ng build --watch --configuration development",
		"test": "ng test",
		"lint": "ng lint",
		"lint:ci": "ng lint",
		"lint:fix": "ng lint --fix",
		"e2e": "ng e2e",
		"ci:start-ng": "angular-http-server --path ./dist/base-angular -p 4200"
	},
	"private": true,
	"dependencies": {
		"@ali-hm/angular-tree-component": "12.0.5",
		"@angular/animations": "^19.2.6",
		"@angular/cdk": "^19.2.9",
		"@angular/common": "^19.2.6",
		"@angular/compiler": "^19.2.6",
		"@angular/core": "^19.2.6",
		"@angular/forms": "^19.2.6",
		"@angular/material": "^19.2.9",
		"@angular/platform-browser": "^19.2.6",
		"@angular/platform-browser-dynamic": "^19.2.6",
		"@angular/router": "^19.2.6",
		"@angular/service-worker": "^19.2.6",
		"@angular/youtube-player": "^19.2.9",
		"@asaasdev/atlas": "24.4.0",
		"@datadog/browser-logs": "^6.6.3",
		"@datadog/browser-rum": "^6.6.3",
		"@hotjar/browser": "^1.0.9",
		"@juggle/resize-observer": "^3.4.0",
		"@ng-select/ng-select": "^14.4.0",
		"@ngx-loading-bar/core": "^7.0.0",
		"@ngx-loading-bar/http-client": "^7.0.0",
		"@ngx-translate/core": "^16.0.4",
		"@ngx-translate/http-loader": "^16.0.1",
		"@playwright/test": "^1.51.1",
		"@segment/analytics-next": "^1.79.0",
		"bootstrap": "^5.3.5",
		"bootstrap-icons": "^1.11.3",
		"chart.js": "^4.4.8",
		"cross-spawn": "^7.0.6",
		"echarts": "^5.6.0",
		"lodash-es": "^4.17.21",
		"luxon": "^3.6.1",
		"ngx-bootstrap": "^19.0.2",
		"ngx-cookie-service": "^19.1.2",
		"ngx-echarts": "^19.0.0",
		"ngx-image-cropper": "^9.1.5",
		"ngx-mask": "^19.0.6",
		"ngx-permissions": "^19.0.0",
		"ngx-scrollbar": "^18.0.0",
		"ngx-toastr": "^19.0.0",
		"rxjs": "~7.8.2",
		"tslib": "^2.8.1",
		"uuid": "^11.1.0",
		"web-pki": "^2.16.3",
		"zone.js": "~0.15.0"
	},
	"devDependencies": {
		"@angular-devkit/build-angular": "^19.2.7",
		"@angular-eslint/builder": "19.3.0",
		"@angular-eslint/eslint-plugin": "19.3.0",
		"@angular-eslint/eslint-plugin-template": "19.3.0",
		"@angular-eslint/schematics": "19.3.0",
		"@angular-eslint/template-parser": "19.3.0",
		"@angular/cli": "^18.2.19",
		"@angular/compiler-cli": "^19.2.6",
		"@types/fs-extra": "^11.0.4",
		"@types/jasmine": "~5.1.7",
		"@types/lodash-es": "^4.17.12",
		"@types/luxon": "^3.6.2",
		"@types/node": "^22.14.0",
		"@typescript-eslint/eslint-plugin": "^8.29.1",
		"@typescript-eslint/parser": "^8.29.1",
		"angular-http-server": "^1.12.0",
		"eslint": "^9.24.0",
		"eslint-config-prettier": "^10.1.2",
		"eslint-plugin-prettier": "^5.2.6",
		"fs-extra": "^11.3.0",
		"jasmine-core": "~5.6.0",
		"karma": "~6.4.4",
		"karma-chrome-launcher": "~3.2.0",
		"karma-coverage": "~2.2.1",
		"karma-jasmine": "~5.1.0",
		"karma-jasmine-html-reporter": "~2.1.0",
		"prettier": "^3.5.3",
		"pretty-quick": "^4.1.1",
		"start-server-and-test": "^2.0.11",
		"typescript": "~5.8.3"
	},
	"overrides": {
		"@angular-devkit/build-angular": {
			"vite": "6.2.6"
		}
	}
}
